import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=d7c9c3bc&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=d7c9c3bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7c9c3bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7c9c3bc')) {
      api.createRecord('d7c9c3bc', component.options)
    } else {
      api.reload('d7c9c3bc', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=d7c9c3bc&scoped=true&", function () {
      api.rerender('d7c9c3bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2AXi48IWqYpf0/JS/teamMember.vue"
export default component.exports